<div class="data-table-container mt-1">
  <ng-container *ngIf="title">
    <h4 class="font-weight-bold">{{ title | translate }}</h4>
  </ng-container>

  <div class="table-header d-flex flex-row justify-content-between">
    <div class="leftHeader">
      <div *ngIf="searchable" class="search-container mb-3">
        <div class="input-group mb-4 col-12 col-md-6 col-lg-4">
          <span class="input-group-text bg-white"
            ><i class="icon-search-lg"></i
          ></span>
          <input
            type="text"
            class="form-control search-input col-12 col-md-6 col-lg-4"
            [placeholder]="searchPlaceHolder | translate"
            [(ngModel)]="searchTerm"
            [disabled]="disabled"
            (keyup)="handleSearch($event)"
            (keyup.enter)="handleSearch($event)" />
        </div>
      </div>
    </div>
    <!-- <div class="rightHeader"></div> -->
  </div>

  <div class="table-responsive">
    <table class="table" [ngClass]="customTableClass">
      <thead>
        <tr>
          <th *ngIf="selectable" style="width: 40px">
            <input
              *ngIf="maxSelection !== 1"
              type="checkbox"
              [checked]="
                selectedItems.length === currentPageData.length &&
                currentPageData.length > 0
              "
              (click)="toggleSelectAll($event)"
              (keydown)="toggleSelectAll($event)"
              [disabled]="disabled" />
          </th>

          <th
            *ngFor="let column of columns"
            [sortable]="column.sortable && !disabled ? column.key : ''"
            [ngClass]="{ sortable: column.sortable }"
            (sort)="onSort($event)"
            [disabled]="disabled || !column.sortable"
            [style.width]="column.width">
            <div class="d-flex align-items-center gap-1">
              <span
                *ngIf="column.sortable && !disabled"
                class="icon-chevron-selector-vertical">
              </span>
              {{ column.title | translate }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="!rowTemplate && !loading">
          <tr
            *ngFor="let row of currentPageData"
            [class.selected-row]="isSelected(row)"
            (click)="selectable ? toggleSelection(row) : null"
            (keydown)="selectable ? toggleSelection(row) : null">
            <td *ngIf="selectable">
              <input
                type="checkbox"
                [checked]="isSelected(row)"
                [disabled]="disabled" />
            </td>

            <td *ngFor="let column of columns">
              {{ row[column.key] | translate }}
            </td>
          </tr>
        </ng-container>

        <ng-container *ngIf="rowTemplate && !loading">
          <ng-container *ngFor="let row of currentPageData">
            <ng-template
              [ngTemplateOutlet]="rowTemplate"
              [ngTemplateOutletContext]="getRowContext(row)">
            </ng-template>
          </ng-container>
        </ng-container>

        <tr *ngIf="currentPageData.length === 0 && !loading">
          <td
            [colSpan]="columns.length + (selectable ? 1 : 0)"
            class="text-center text-muted py-4">
            {{ emptyMessage | translate }}
          </td>
        </tr>

        <ng-container *ngIf="loading">
          <tr *ngFor="let item of shimmerTableSize">
            <td *ngIf="selectable">
              <div class="line loading-shimmer"></div>
            </td>

            <td *ngFor="let column of columns">
              <div class="line loading-shimmer"></div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="w-100 mt-3 px-4" *ngIf="collectionSize > pageSize">
      <irembogov-data-table-pagination
        [minimalPagination]="minimalPagination"
        [showDirectionText]="true"
        [collectionSize]="collectionSize"
        [page]="currentPage"
        [disabled]="disabled"
        [pageSize]="pageSize"
        [showDropdown]="true"
        (paginatedValues)="
          onPageChange($event)
        "></irembogov-data-table-pagination>
    </div>
  </div>
</div>
